import { collection, deleteDoc, doc, getDocs, limit, onSnapshot, orderBy, query, serverTimestamp, updateDoc, type Unsubscribe } from "firebase/firestore";
import { db } from "../firebase/client";
import type { InAppNotification } from "./notificationTypes";

export async function listNotifications(uid: string, count = 50): Promise<InAppNotification[]> {
  const snapshot = await getDocs(query(collection(db, "users", uid, "notifications"), orderBy("createdAt", "desc"), limit(count)));
  return snapshot.docs.map((item) => ({ id: item.id, ...(item.data() as Omit<InAppNotification, "id">) }));
}

export async function markNotificationRead(uid: string, id: string): Promise<void> {
  await updateDoc(doc(db, "users", uid, "notifications", id), { readAt: serverTimestamp() });
}

export async function deleteNotification(uid: string, id: string): Promise<void> {
  await deleteDoc(doc(db, "users", uid, "notifications", id));
}


export function subscribeNotifications(uid: string, callback: (items: InAppNotification[]) => void, count = 50): Unsubscribe {
  return onSnapshot(
    query(collection(db, "users", uid, "notifications"), orderBy("createdAt", "desc"), limit(count)),
    (snapshot) => callback(snapshot.docs.map((item) => ({ id: item.id, ...(item.data() as Omit<InAppNotification, "id">) }))),
    () => undefined
  );
}
